import React from "react";
import PropTypes from "prop-types";
import { InfoTitle, InfoField, InfoInlineWrap } from "../style";

export default function InfoInline({
  title,
  value,
  wordBreakOnly = false,
  isPrint = false,
}) {
  return (
    <InfoInlineWrap>
      <InfoTitle as="span" className="mr1">
        {title}
      </InfoTitle>
      <InfoField isPrint={isPrint} wordBreakOnly={wordBreakOnly} as="span">
        {value}
      </InfoField>
    </InfoInlineWrap>
  );
}

InfoInline.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  wordBreakOnly: PropTypes.bool,
  isPrint: PropTypes.bool,
};
